<template>
    <div>
        <CardBase>
            <!-- Header -->
            <MacroSubHeader
                title="Agenda"
                icon="el-icon-notebook-1"
            >
                <template slot="actions">
                    <div>
                        <el-button
                            v-if="isAuthorized"
                            size="small" 
                            type="primary"
                            plain
                            @click="goToScheduleParameters"
                        >
                            <i class="el-icon-setting"></i>
                            Configurar Parâmetros
                        </el-button>
                        
                        <el-popover
                            placement="bottom-end"
                            width="200"
                            trigger="click"
                        >
                            <el-button
                                size="small" 
                                plain
                                class="mr-2"
                                slot="reference"
                            >
                                
                                <i class="el-icon-notebook-1"></i>
                                Exportar Agenda
                                <i class="el-icon-arrow-down"></i>
                            </el-button>

                            <div class="d-flex flex-column" :style="{ gap: '4px' }">
                                <div class="flex-grow-1">
                                    <el-button
                                        plain
                                        @click="exportarAgendaParaPdf('CALENDAR')"
                                        :style="{ width: '100%' }"
                                        class="text-left"
                                    >
                                        <i class="el-icon-date"></i>
                                        Calendário
                                    </el-button>
                                </div>

                                <div class="flex-grow-1">
                                    <el-button
                                    plain
                                    class="text-left"
                                    @click="exportarAgendaParaPdf('LIST')"
                                    :style="{ width: '100%' }"
                                >
                                    <i class="el-icon-tickets"></i>
                                    Lista
                                </el-button>
                                </div>
                            </div>
                        </el-popover>
                        
                        
                        <!-- Exportar relatorios -->
                        <EventsExportReports/>
                    </div>
                </template>
            </MacroSubHeader>
            
            <el-row>
                <el-col :span="18">
                    <CardBase border="border-right">
                        <!-- Filters -->
                        <el-row>
                            <el-form label-position="top" class="mb-3">
                                <div class="d-flex justify-content-between" :style="{ gap: '12px' }">
                                    
                                    <div class="d-flex align-items-center" :style="{ gap: '20px' }">
                                        <el-button
                                            size="small" 
                                            plain
                                            @click="goToday"
                                            round
                                        >
                                            <i class="el-icon-sunny"></i>
                                            Hoje
                                        </el-button>
        
                                        <div class="d-flex align-items-center" :style="{ gap: '20px' }">
                                            <el-button
                                                size="small" 
                                                circle
                                                @click="goPrev"
                                                class="border-0"
                                            >
                                                <i class="el-icon-arrow-left"></i>
                                            </el-button>
        
                                            <h5 class="mb-0 font-weight-bolder">{{ calendarTitle }}</h5>
                
                                            <el-button
                                                size="small" 
                                                circle
                                                @click="goNext"
                                                class="border-0"
                                            >
                                                <i class="el-icon-arrow-right"></i>
                                            </el-button>
                                        </div>
                                    </div>
        
                                    <div class="d-flex align-items-center" :style="{ gap: '12px' }">
        
                                        <el-select
                                            size="small"
                                            v-model="filters.status"
                                            placeholder="Selecionar status"
                                            filterable 
                                            clearable
                                            @change="fetch()"
                                        >
                                            <el-option :value="null">Todos</el-option>
                                            <el-option
                                                v-for="(stat) in status"
                                                :key="stat.value"
                                                :value="stat.value"
                                            >
                                                <div class="d-flex align-items-center">
                                                    <el-tag 
                                                        v-if="stat.value != null"
                                                        :type="getEventColorByStatus(stat.value)" 
                                                        size="mini"
                                                        :style="{ width: '20px' }"
                                                        class="rounded-circle mr-2"
                                                    >
                                                    </el-tag>
                                                    {{ stat.text }}
                                                </div>
                                            </el-option>
                                        </el-select>
        
                                        <el-button
                                            size="small" 
                                            type="primary"
                                            round
                                            @click="handleDateClickByAction"
                                            :disabled="isLoading"
                                        >
                                            <i class="el-icon-plus"></i>
                                            Novo Evento
                                        </el-button>
                                    </div>
                                </div>
                            </el-form>
                        </el-row>
        
                        <el-tabs type="border-card" v-model="activeName" @tab-click="handleTabClick">
                            <el-tab-pane name="first" lazy>
                                <span slot="label">
                                    <i class="el-icon-date"></i>
                                    <span class="ml-1">Calendário</span>
                                </span> 
                        
                                <!-- Calendar -->
                                <div class="custom-calendar">
                                    <FullCalendar ref="fullCalendar" :options="finalCalendarOptions">
                                        <template v-slot:eventContent="info">
                                            <el-button 
                                                class="rounded-pill" 
                                                :style="{ width: '100%', textAlign: 'start' }" 
                                                size="small"
                                                plain
                                                :type="getEventColorByStatus(info.event.extendedProps.status)"
                                            >
                                                <div class="text-truncate">{{ info.event.title }}</div>
                                            </el-button>
                                        </template>
                                    </FullCalendar>
                                </div>
                            </el-tab-pane>
            
                            <el-tab-pane name="second">
                                <span slot="label">
                                    <i class="el-icon-tickets"></i>
                                    <span class="ml-1">Lista</span>
                                </span> 
        
                                <EventsSemanalView
                                    :events="data"
                                    :reference-date="calendarDate"
                                    @dispatch="handleDispatch"
                                    @handleEvent="handleEventClick"
                                />
                            </el-tab-pane>
                        </el-tabs>
                    </CardBase>
                </el-col>
    
                <el-col :span="6">
                    <CardBase size="none">
                        <CardBase
                            v-if="isAuthorizedSearchSales"
                            class="relative" 
                        >  
                            <div class="d-flex align-items-center mb-3">
                                <i class="el-icon-notebook-1 mr-2"></i>
                                <h6 class="mb-0 font-weight-bolder">Outras agendas</h6>
                            </div>
    
                            <div class="d-flex align-items-center">
                                <el-select
                                    size="small"
                                    v-model="filters.consultant_user_id"
                                    placeholder="Selecionar consultor"
                                    :disabled="isLoading"
                                    filterable 
                                    @change="fetch()"
                                >
                                    <el-option
                                        v-for="(sale) in sales"
                                        :key="sale.user_id"
                                        :label="sale.text"
                                        :value="sale.user_id"
                                    />
                                </el-select>

                                <el-button 
                                    v-if="filters.consultant_user_id"
                                    type="danger" 
                                    circle 
                                    plain 
                                    size="mini" 
                                    @click.native.prevent="handleConsultant()"
                                    class="ml-2"
                                >
                                    <i class="el-icon-delete"></i>
                                </el-button>
                            </div>
    
                        </CardBase>
    
                        <CardBase border="border-top">
                            <div class="d-flex justify-content-end">
                                <el-dropdown size="mini" split-button plain @command="handleSetValuesOrder">
                                    <strong>Tipo</strong>:  {{ values_order == 'monthly' ? 'Mensal' : 'Anual' }}
                                    <el-dropdown-menu slot="dropdown">
                                        <el-dropdown-item command="monthly">
                                            <div class="d-flex align-items-center">
                                                <i class="el-icon-top mr-2"></i>
                                                Mensal
                                            </div>
                                        </el-dropdown-item>
                                        <el-dropdown-item command="yearly">
                                            <div class="d-flex align-items-center">
                                                <i class="el-icon-bottom mr-2"></i>
                                                Anual
                                            </div>
                                        </el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>
                            </div>

                            <!-- Indicators -->
                            <div class="d-flex flex-column" :style="{ gap: '12px' }">
                                <CardBase :border="['border-left', 'border-bottom']" radius="small">
                                    <div class="d-flex align-items-center justify-content-between">
                                        <h6 class="mb-0 font-weight-bold">Valor estimado</h6>
                                        <el-button size="small" type="primary" plain circle>
                                            <i class="el-icon-coin"></i>
                                        </el-button>
                                    </div>
                                    <h6 class="mb-0">R$ {{ getValor.valorEstimado.toString().replace(".", ",") }}</h6>
                                </CardBase>

                                <CardBase border="border-all" radius="medium">
                                    <div class="d-flex align-items-center justify-content-between">
                                        <h6 class="mb-0 font-weight-bold">Valor utilizado</h6>
                                        <el-button size="small" type="success" plain circle>
                                            <i class="el-icon-coin"></i>
                                        </el-button>
                                    </div>
                                    <h6 class="mb-0">R$ {{ getValor.valorUtilizado.toString().replace(".", ",") }}</h6>
                                </CardBase>
                    
                                <CardBase :border="['border-top', 'border-right']" radius="small">
                                    <div class="d-flex align-items-center justify-content-between">
                                        <div class="d-flex align-items-center" :style="{ gap: '12px' }">
                                            <h6 class="mb-0 font-weight-bold">Valor não utilizado</h6>
                                        </div>
                                        <el-button size="small" type="danger" plain circle>
                                            <i class="el-icon-coin"></i>
                                        </el-button>
                                    </div>
                                    <h6 class="mb-0">R$ {{ getValor.valorNaoUtilizado.toString().replace(".", ",") }}</h6>
                                </CardBase>
                            </div>  
                        </CardBase>
                    </CardBase>
                </el-col>
            </el-row>
        </CardBase>
    
        <!-- Event Create Modal -->
        <EventCreateModal ref="eventCreateModal" @created="handleDispatch"/>

        <!-- Event Show Modal -->
        <EventShowModal ref="eventShowModal" @dispatch="handleDispatch"/>

        <!-- Export To PDF -->
        <EventsExportToPdf
            :date="calendarTitle" 
            :user-schedule-name="selectedConsultantText"
            :status="status"
            :despesas="[
                {
                    id: 1,
                    text: 'Viagem',
                    icon: 'el-icon-map-location'
                },
                {
                    id: 2,
                    text: 'Hospedagem',
                    icon: 'el-icon-school'
                },
                {
                    id: 3,
                    text: 'Almoço',
                    icon: 'el-icon-food'
                },
                {
                    id: 4,
                    text: 'Jantar',
                    icon: 'el-icon-dish'
                },
            ]"
            ref="eventsExportToPdf"
        >
            <template slot="calendar">
                <!-- Calendar -->
                <div v-if="export_schedule_format == 'CALENDAR'" class="custom-calendar">
                    <FullCalendar ref="fullCalendarExport" :options="finalCalendarOptions">
                        <template v-slot:eventContent="info">
                            <el-tag 
                                class="rounded-pill text-truncate" 
                                :style="{ width: '100%' }" 
                                size="small"
                                :type="getEventColorByStatus(info.event.extendedProps.status)"
                            >
                                {{ info.event.title }}
                            </el-tag>
                        </template>
                    </FullCalendar>
                </div>

                <!-- List -->
                <EventsSemanalView
                    v-if="export_schedule_format == 'LIST'"
                    :events="data"
                    :reference-date="calendarDate"
                    @dispatch="handleDispatch"
                    @handleEvent="handleEventClick"
                    :isExport="true"
                />

            </template>
        </EventsExportToPdf>
    </div>
</template>
<script>
    // Fullcalendar configs
    import dayGridPlugin from "@fullcalendar/daygrid";
    import interactionPlugin from "@fullcalendar/interaction";
    import timeGridPlugin from "@fullcalendar/timegrid";
    import ptLocale from "@fullcalendar/core/locales/pt-br";

    // pdf
    import html2canvas from "html2canvas";
    import jsPDF from "jspdf";

    // Components
    import MacroSubHeader from "@/components/_macro/MacroSubHeader.vue";
    import CardBase from "@/components/_macro/CardBase.vue";
    import FullCalendar from "@fullcalendar/vue";
    import EventCreateModal from "./EventCreateModal.vue";
    import EventShowModal from "./EventShowModal.vue";
    import EventsExportToPdf from "./EventsExportToPdf.vue";
    import EventsExportReports from "./EventsExportReports.vue";
    import EventsSemanalView from "./EventsSemanalView.vue"
    
    import {
        Card,
        Button,
        Row,
        Col,
        Form,
        FormItem,
        Select,
        Option,
        RadioGroup,
        RadioButton,
        Notification,
        Tag,
        Avatar,
        Dropdown,
        DropdownMenu,
        DropdownItem,
        Empty,
        Tabs,
        TabPane,
        Popover,
    } from 'element-ui'

    //Api
    import { VendedorApi } from "@/api/VendedorApi";
    const vendedorApi = new VendedorApi();

    import { AgendaApi } from "@/api/AgendaApi";
    const agendaApi = new AgendaApi();

    export default {
        data() {
            return {
                activeName: 'first',
                calendarTitle: '',
                // Data de referência (mês/ano) atualmente exibida no
                // calendário. Mantida reativa e sincronizada pelo
                // "datesSet" do FullCalendar para alimentar o EventsSemanalView.
                calendarDate: new Date(),
                filters: {
                    consultant_user_id: null,
                    status: null,
                },
                calendarOptions: {
                    headerToolbar: {
                        left: '',
                        center: '',
                        right: ''
                    },
                    dayCellClassNames: this.getDayCellClassNames,
                    eventColor: 'transparent',
                    plugins: [dayGridPlugin, interactionPlugin, timeGridPlugin],
                    locale: ptLocale,
                    height: 866,
                    dateClick: this.handleDateClick,
                    eventClick: this.handleEventClick,
                    datesSet: (info) => {
                        this.calendarTitle = info.view.title;
                        // "currentStart" é o primeiro dia do mês exibido na
                        // grade mensal, usado como referência pelo EventsSemanalView
                        this.calendarDate = info.view.currentStart;
                    },
                    events: []
                },
                status: [
                    { value: "CUMPRIDO", text: "Cumpriu" },
                    { value: "PENDENTE", text: "Pendente" },
                    { value: "APROVADO", text: "Aprovado" },
                    { value: "NAO CUMPRIU", text: "Não cumpriu" },
                    { value: "REPROVADO", text: "Reprovado" },
                ],
                data: [],
                sales: [],
                isLoading: false,
                values_order: 'monthly',
                export_schedule_format: 'CALENDAR'
            }
        },
        methods: {
            async fetch() {
                try {
                    this.isLoading = true;
                    const res = await agendaApi.index(this.filters);

                    this.data = res.data;
                } catch (error) {
                    Notification.error({
                        title: 'Erro',
                        message: 'Não foi possível obter as agendas. Algo inesperado ocorreu!'
                    });
                } finally {
                    this.isLoading = false;
                }
            },
            /**
             * Obtem os vendedores
             */
            async getSales() {
                try {
                    this.isLoading = true;
                    const res = await vendedorApi.pluck()

                    this.sales = res.data;
                } catch (error) {
                    Notification.error({
                        title: 'Erro',
                        message: 'Não foi possível obter os vendedores!'
                    });
                } finally {
                    this.isLoading = false;
                }
            },
            /**Calendar events */
            handleDatesSet(info) {
                this.calendarTitle = info.view.title;
            },
            handleDateClick: function (info) {                
                const isBeforeToday = this.dateIsBeforeToday(info.date)

                if (isBeforeToday) {
                    Notification.warning({
                        title: 'Aviso',
                        message: 'Não é possível criar um evento em uma data passada.'
                    });
                    return; // interrompe o fluxo, nenhuma outra ação acontece
                }

                // Fornencendo data para payload modal
                this.$refs.eventCreateModal.payload.data = info.date;
                
                return this.$refs.eventCreateModal.toggleModal()
            },
            handleEventClick: async function (payload) {
                this.$refs.eventShowModal.eventId = payload.event.id;

                const elLoading = this.$loading({ lock: true })

                await this.$refs.eventShowModal.getEvent();

                elLoading.close();

                // Passivel de edição?
                const isBeforeToday = this.dateIsBeforeToday(payload.event.start);

                this.$refs.eventShowModal.canBeEdited = isBeforeToday;

                return this.$refs.eventShowModal.toggleModal()
            },
            handleDateClickByAction() {
                const today = new Date();

                // Fornencendo data para payload modal
                this.$refs.eventCreateModal.payload.data = today;

                return this.$refs.eventCreateModal.toggleModal()
            },
            getCalendarApi() {
                return this.$refs.fullCalendar.getApi();
            },
            getCalendarExportApi() {
                return this.$refs.fullCalendarExport.getApi();
            },
            goToday() {
                this.getCalendarApi().today();
                this.getCalendarExportApi().today();
            },
            goPrev() {
                this.getCalendarApi().prev();
                this.getCalendarExportApi().prev();
            },
            goNext() {
                this.getCalendarApi().next();
                this.getCalendarExportApi().next();
            },
            getDayCellClassNames(arg) {
                const today = new Date();
                today.setHours(0, 0, 0, 0);

                if (arg.date < today) {
                    return ['fc-day-disabled'];
                }
                return [];
            },
            cleanFilters() {
                this.filters = {
                    consultant_user_id: null,
                    status: null,
                }
            },
            getEventColorByStatus(status) {
                switch(status) {
                    case 'APROVADO':
                        return 'success'
                    case 'PENDENTE':
                        return 'warning'
                    case 'CUMPRIDO':
                        return '' 
                    case 'NAO CUMPRIU':
                        return 'danger' 
                    case 'REPROVADO':
                        return 'info' 
                    default: 
                        return 'info'
                }
            },
            /** Converte a data do evento evitando shift de dia por timezone */
            parseEventDate(dateValue) {
                if (!dateValue) {
                    return null;
                }

                const rawDate = String(dateValue).split('T')[0];

                return new Date(`${rawDate}T12:00:00`);
            },
            dateIsBeforeToday(date) {
                const today = new Date();
                today.setHours(0, 0, 0, 0);

                const clickedDate = new Date(date);
                clickedDate.setHours(0, 0, 0, 0);

               if (clickedDate < today) {
                    return true;
                }

                return false;
            },
            async handleDispatch() {
                await this.fetch()
            },
            async handleConsultant() {
                this.filters.consultant_user_id = null

                await this.fetch()
            },
            exportarAgendaParaPdf(type) {
                if(type == 'CALENDAR') {
                    this.export_schedule_format = 'CALENDAR';
                    this.$refs.eventsExportToPdf.exportarAgendaParaPdf();
                }

                if(type == 'LIST') {
                    this.export_schedule_format = 'LIST';
                    this.$refs.eventsExportToPdf.exportarAgendaParaPdf();
                }
            },
            goToScheduleParameters() {
                window.location.assign('/adm/agenda-parametros/');
            },
            /**
             * O FullCalendar fica com o container em display:none enquanto
             * a aba "Lista" está ativa (o el-tabs não desmonta o painel,
             * apenas o esconde) e perde a referência de largura. Ao voltar
             * para a aba "Calendário", forçamos um recálculo do tamanho.
             */
            handleTabClick(tab) {
                if (tab.name !== 'first') {
                    return;
                }

                this.$nextTick(() => {
                    this.getCalendarApi().updateSize();
                });
            },
            async handleSetValuesOrder(orderBy) {
                if (orderBy == this.values_order) return

                this.values_order = orderBy;
            },
        },
        computed: {
            isAuthorized() {
                return this.$store.getters['user/isAnyRole'](['adm', 'coord_comercial']);
            },
            isAuthorizedSearchSales() {
                return this.$store.getters['user/isAnyRole']([
                    'adm', 'coord_comercial', 'diretor_nacional',
                    'gerente_nacional', 'gerente_regional', 'gestor_varejo',
                    'analista_farma'
                ]);
            },
            calendarEvents() {
                if (this.data.length > 0) {
                    return this.data.map(item => ({
                        id: item.id,
                        title: item.titulo,
                        status: item.status,
                        start: item.data, // formato 'YYYY-MM-DD' ou ISO
                    }));
                }

                return [];
            },
            // Mescla as opções fixas com os eventos dinâmicos
            finalCalendarOptions() {
                return {
                    ...this.calendarOptions,
                    events: this.calendarEvents,
                };
            },
            /**
             * Eventos considerados nos cards de "Valores previstos", de
             * acordo com o filtro local (mensal/anual). Mensal considera
             * somente o mês exibido no calendário; anual considera o ano
             * inteiro, já que a agenda é referente a um período anual.
             */
            valoresFilteredData() {
                const refDate = this.calendarDate ? new Date(this.calendarDate) : new Date();
                const year = refDate.getFullYear();
                const month = refDate.getMonth();

                return (this.data || []).filter((el) => {
                    const eventDate = this.parseEventDate(el.data);

                    if (!eventDate) {
                        return false;
                    }

                    if (this.values_order === 'yearly') {
                        return eventDate.getFullYear() === year;
                    }

                    return eventDate.getFullYear() === year && eventDate.getMonth() === month;
                });
            },
            getValor() {
                let valorEstimado = 0.0;
                let valorUtilizado = 0.0;
                let valorNaoUtilizado = 0.0;

                if (this.valoresFilteredData && this.valoresFilteredData.length > 0) {
                    this.valoresFilteredData.forEach((el) => {
                        let estacionamento = 0.0;
                        let pedagio = 0.0;

                        if (el.despesas) {
                            el.despesas.forEach((il) => {
                                if (il.tipo == "ESTACIONAMENTO") {
                                    estacionamento += parseFloat(il.valor);
                                } else if (il.tipo == "PEDAGIO") {
                                    pedagio += parseFloat(il.valor);
                                }
                            });
                        }

                        valorEstimado += estacionamento + pedagio;

                        if (el.cumpriu == "SIM") {
                            valorUtilizado += parseFloat(estacionamento + pedagio);
                        }

                        if (el.cumpriu == "NAO") {
                            valorNaoUtilizado += parseFloat(estacionamento + pedagio);
                        }

                        if (el.hospedagem) {
                            valorEstimado += parseFloat(el.parametros.valor_hospedagem);
                            if (el.cumpriu == "SIM") {
                                valorUtilizado += parseFloat(el.parametros.valor_hospedagem);
                            }
                            if (el.cumpriu == "NAO") {
                                valorNaoUtilizado += parseFloat(el.parametros.valor_hospedagem);
                            }
                        }

                        if (el.almoco) {
                            valorEstimado += parseFloat(el.parametros.valor_almoco);
                            if (el.cumpriu == "SIM") {
                                valorUtilizado += parseFloat(el.parametros.valor_almoco);
                            }
                            if (el.cumpriu == "NAO") {
                                valorNaoUtilizado += parseFloat(el.parametros.valor_almoco);
                            }
                        }

                        if (el.jantar) {
                            valorEstimado += parseFloat(el.parametros.valor_jantar);
                            if (el.cumpriu == "SIM") {
                                valorUtilizado += parseFloat(el.parametros.valor_jantar);
                            }
                            if (el.cumpriu == "NAO") {
                                valorNaoUtilizado += parseFloat(el.parametros.valor_jantar);
                            }
                        }
                    });
                }

                return {
                    valorEstimado: parseFloat(valorEstimado).toFixed(2),
                    valorUtilizado: parseFloat(valorUtilizado).toFixed(2),
                    valorNaoUtilizado: parseFloat(valorNaoUtilizado).toFixed(2),
                };
            },
            selectedConsultant() {
                if (!this.filters.consultant_user_id) {
                    return null;
                }

                return this.sales.find(
                    sale => sale.user_id === this.filters.consultant_user_id
                ) || null;
            },
            selectedConsultantText() {
                return this.selectedConsultant?.text || null;
            }
        },
        watch: {
            "filters.consultant_user_id"(_newValue) {
                this.$refs.eventCreateModal.payload.user_id = _newValue.toString();
                this.$refs.eventCreateModal.salesConsultant = this.selectedConsultantText;
                this.fetch() 
            }
        },
        async created() {
            await this.fetch();

            if(this.isAuthorizedSearchSales) {
                await this.getSales();
            }
        },
        components: {
            MacroSubHeader,
            CardBase,
            FullCalendar,
            EventCreateModal,
            EventShowModal,
            EventsExportToPdf,
            EventsExportReports,
            EventsSemanalView,
            [Card.name]: Card,
            [Button.name]: Button,
            [Row.name]: Row,
            [Col.name]: Col,
            [Select.name]: Select,
            [Option.name]: Option,
            [RadioGroup.name]: RadioGroup,
            [RadioButton.name]: RadioButton,
            [Notification.name]: Notification,
            [Tag.name]: Tag,
            [Avatar.name]: Avatar,
            [Dropdown.name]: Dropdown,
            [DropdownMenu.name]: DropdownMenu,
            [DropdownItem.name]: DropdownItem,
            [Empty.name]: Empty,
            [Tabs.name]: Tabs,
            [TabPane.name]: TabPane,
            [Popover.name]: Popover,
        }
    }
</script>
<style lang="scss">
    .card-indicator {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        flex-grow: 1;
        padding: 16px;
        background-color: #FFF;
        border: 1px solid #dedede;
        border-radius: 20px;
        height: 110px;

        box-shadow: rgba(0, 0, 0, 0.05) 0px 1px 2px 0px;

        &.destach {
            background-color: #f56c6c13;
        }

        &.type-min {
            height: 65px;
        }

        >.card-indicator--header {
            display: flex;
            align-items: center;
            justify-content: space-between;
        }
    }

    .custom-calendar {
        --fc-primary: #7c3aed;
        --fc-primary-hover: #6d28d9;
        --fc-primary-active: #5b21b6;
        --fc-border: #e5e7eb;
        --fc-today: #ede9fe;
        margin-top: -24px;
        width: 100%;

        .fc-day {

            &.fc-day-today {
                .fc-daygrid-day-frame {
                    
                    .fc-daygrid-day-number {
                        background-color: var(--fc-today) !important;
                        padding: 2px 6px;
                        font-weight: 500;
                        border-radius: 999px;
                    }
                }
            }

            &.fc-daygrid-day {
                border: none !important;
                padding: 4px !important;
                background: none;
            }

            .fc-daygrid-day-frame {
                border: 1px solid #e5e7eb;
                border-radius: 15px;
                background: #fff;
                height: 100%;
                min-height: 127px;
                box-sizing: border-box;
                padding: 4px;

                display: flex;
                flex-direction: column;
                gap: 4px;
            }

            &.fc-day-disabled {
                .fc-daygrid-day-frame {
                    background-color: #fff;
                    background-image: repeating-linear-gradient(
                        135deg,
                        #fff 0,
                        #fff 7px,
                        #eeeeee 7px,
                        #eeeeee 8px
                    );
                }
                    
                &.fc-daygrid-day-number {
                    color: #c0c4cc;
                }
            }

            &:hover {
                .fc-daygrid-day-frame {
                    background-color: #ede9fe;
                    cursor: pointer;

                }
            }
        }

        .fc-h-event {
            border: none;
        }

        .fc-theme-standard td, .fc-theme-standard th {
            border: none;
        }

        .fc-theme-standard .fc-scrollgrid {
            border: none;
        }
    }

    .custom-calendar .fc .fc-button {
        background-color: var(--fc-primary);
        border-color: var(--fc-primary);
    }

    .custom-calendar .fc .fc-button:hover {
        background-color: var(--fc-primary-hover);
        border-color: var(--fc-primary-hover);
    }

    .custom-calendar .fc .fc-button-primary:not(:disabled).fc-button-active {
        background-color: var(--fc-primary-active);
        border-color: var(--fc-primary-active);
    }

    .custom-calendar .fc-theme-standard td,
    .custom-calendar .fc-theme-standard th {
        border-color: var(--fc-border);
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/agenda/Index.vue